import {Box, Grid, IconButton, TextField} from "@mui/material";
import React, {useState} from "react";
import {IContaContabilRecursoLimite} from "@models/contaContabil/IContaContabilRecursoLimite.ts";
import {MoneyInputEntry} from "@shared/specialComponents/InputEntry.tsx";
import dayjs from "dayjs";
import {TaskAlt} from "@mui/icons-material";
import {fullHeight} from "@models/helpers.ts";
import {
    CreateOrUpdateLimiteContaContabilRecurso
} from "@components/contaContabil/endpoints/__contacontabil_endpoints.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {ToMoney} from "@shared/MathHelp.ts";
import {ISolicitacao} from "@models/solicitacoes/solicitacoes.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface RecursoContaContabilLimiteEntryProps {
    recursoId?: number,
    contaContabilId?: number,
    limiteInitial?: IContaContabilRecursoLimite
    solicitacoes?: ISolicitacao[]
    onSendLimite?: (limite: IContaContabilRecursoLimite) => void
}

export function RecursoContaContabilLimiteEntry(props: RecursoContaContabilLimiteEntryProps) {
    const {Get} = useApi();
    const {createAlertFromResponse} = useAlert();
    const [recursoStart, setRecursoStart] = useState(props.limiteInitial ?? undefined);

    const [limite, setLimite] = useState<Partial<IContaContabilRecursoLimite>>(props.limiteInitial || {
        id: 0,
        recursoId: props.recursoId,
        contaContabilId: props.contaContabilId,
        limite: null,
        dataInicio: dayjs(),
        dataFim: dayjs(),
        isAtivo: true,
        dataCriacao: dayjs(),
        vigenciaFinal: dayjs(),
        vigenciaInicial: dayjs(),
        usuarioCriacaoId: 0,
    } as IContaContabilRecursoLimite);

    const handleSendLimite = () => {
        Get(CreateOrUpdateLimiteContaContabilRecurso([limite as IContaContabilRecursoLimite])).then(x => {
            if (x.status == 'Success') {
                setLimite(x.items[0]);
                setRecursoStart(x.items[0]);
                if (props.onSendLimite) {
                    props.onSendLimite(x.items[0]);
                }
            }

            createAlertFromResponse(x);
        });
    };

    const costs = props.solicitacoes?.reduce((acc: { e: number, p: number }, item) => {
        if (item.recursoId == props.recursoId && item.contaContabilId == props.contaContabilId) {
            const v = item.movimentacoes?.reduce((acc2: { e: number, p: number }, v) => {
                return {...acc2, e: acc2.e + (v.valorEfetivo ?? 0), p: acc2.p + (v.valorPendente ?? 0)};
            }, {e: 0, p: 0});
            return {
                ...acc,
                e: acc.e + (v?.e ?? 0),
                p: acc.p + (v?.p ?? 0),
            };
        }
        return acc;
    }, {e: 0, p: 0});


    return (
        <Box>
            <Grid container justifyContent={'end'}>
                <Grid size={'grow'}>
                    <Grid container>
                        <Grid size={6}>
                            <TextField value={ToMoney(costs?.e) + '/' + ToMoney(costs?.p)} disabled variant={'standard'}
                                       size={'small'}
                                       label={'Gastos (Efetivado/Pendente)'}/>
                        </Grid>
                        <Grid size={6}>
                            <MoneyInputEntry textFieldProps={{size: 'small', variant: 'standard'}}
                                             label={'Limite de gastos'}
                                             onEnter={handleSendLimite}
                                             onChange={x => setLimite({...limite, limite: x ?? null})}
                                             value={limite?.limite ?? undefined}/>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container justifyContent={'end'} alignItems={'center'}>
                    <IconButton sx={{...fullHeight}}
                                disabled={recursoStart == limite}
                                onClick={handleSendLimite}>
                        <TaskAlt/>
                    </IconButton>
                </Grid>
            </Grid>
        </Box>
    );
}